module.exports = __webpack_public_path__ + "img/menu.6431979a.svg";